import { formatDistanceToNow, format, startOfDay, differenceInCalendarDays } from 'date-fns';
import { enUS, ko, zhCN, zhTW } from 'date-fns/locale';
import { getLanguage } from './etcUtils';

const locales = {
  en: enUS,
  ko: ko,
  'zh-TW': zhTW,
  'zh-CN': zhCN
};

export const getDatefnsLocale = (key) => {
  return locales[key] || locales.en;
};

// PM 01:00 형식을 기본값으로 설정
export function formatDateTime(dateString, formatString = 'a hh:mm') {
  const currentLocale = getDatefnsLocale(getLanguage());
  return format(new Date(dateString), formatString, { locale: currentLocale });
}

export function dateTimeDistanceToNow(dateString) {
  const currentLocale = getDatefnsLocale(getLanguage());

  return formatDistanceToNow(new Date(dateString), {
    addSuffix: true,
    locale: currentLocale
  });
}

// yyyy-MM-dd 형식으로 input[type="date"]에 맞게 포맷
export function transformDateToInputValue(date) {
  const d = typeof date === 'string' ? new Date(date) : date;
  // 로컬 타임존 보정 후 ISO 날짜만 추출
  const tzOffset = d?.getTimezoneOffset();
  const local = new Date(d?.getTime() - tzOffset * 60000);
  return local.toISOString().slice(0, 10);
}

// createdAt로부터 오늘이 몇 일째인지 (오늘 포함: 오늘 = 1일째)
export function daysSinceInclusive(dateString) {
  const createdAt = startOfDay(new Date(dateString));
  const today = startOfDay(new Date());
  const diff = differenceInCalendarDays(today, createdAt);
  return Math.max(1, diff + 1);
}
